export default __webpack_public_path__ + "static/media/php.d04e22af.svg";